import { useEffect, useState } from 'react';
import { laboratoryClient, logExposure } from '../clients/laboratoryClient';
import { useAppContext } from '../context/AppContext';
import { useRecommendedAppsQuery } from './useRecommendedAppsQuery';
export const DEFAULT_EXPERIMENT_ALL_APPS_LENGTH = 48;
export const useIsMpdi0001Group = ({
  group,
  recommendedAppsShown = true
}) => {
  const appContext = useAppContext();
  const [isMpdi0001Group, setIsMpdi0001Group] = useState(false);
  const {
    data: recommendedApps
  } = useRecommendedAppsQuery();
  useEffect(() => {
    // experiment is only available to in-app users
    // check for appContext to avoid unfound experiment errors in public marketplace
    if (appContext === 'public') {
      setIsMpdi0001Group(false);
    } else {
      laboratoryClient.resolve(treatments => {
        if (Object.keys(treatments).length && recommendedApps.length > 0) {
          if (recommendedAppsShown) {
            logExposure('mpdi-0001');
          }
          const treatmentsGroup = treatments['mpdi-0001']['parameters']['group'];
          setIsMpdi0001Group(treatmentsGroup === group);
        } else {
          setIsMpdi0001Group(group === 'control');
        }
      });
    }
  }, [appContext, group, recommendedApps, recommendedAppsShown]);
  return isMpdi0001Group;
};